import { useEffect, useState } from "react"
import { useIntl } from "react-intl"
import moment from 'moment';

import { CalendarItem, Meeting, Props, TabStatus } from "./ScheduledCallsTab.model"

import { useAuthenticationDataContext } from "../../../Helpers/AuthenticationDataProvider"
import useFetchWrapper, { HttpResponse } from "../../../Helpers/useFetchWrapper"
import { useHistory } from "react-router-dom";
import { useAuthorizationDataContext } from "../../../Helpers/AuthorizationDataProvider";

export const useScheduledCallsTab = ({filters}: Props) => {
	const [ tabStatus, setTabStatus ] = useState(TabStatus.Loading);
	const [meetings, setMeetings] = useState<CalendarItem[]>([]);
	const [meetingDetails, setMeetingDetails] = useState<Meeting>();
	const [ showDetailsPopup, setShowDetailsPopup ] = useState<boolean>(false);
	const [ showDeletePopup, setShowDeletePopup ] = useState<boolean>(false);

	const { get, remove } = useFetchWrapper();
	const intl = useIntl();
	const { userId } = useAuthenticationDataContext();
	const { isAuthorized, role } = useAuthorizationDataContext();
	const history = useHistory();


	useEffect(() => {
		getMeetings();
	}, [filters]);


	const deleteMeeting = async (eventId: string) => {
		await remove(`/calendar/events/${eventId}`);
		getMeetings();
	}

	const formatDate = (startDate: string, endDate: string) => {
		const date = moment(startDate).format("DD MMM YYYY");
		const startHour = moment(startDate).format('HH:mm');
		const endHour = moment(endDate).format('HH:mm');
		const duration = moment.duration(moment(endDate).diff(moment(startDate))).asMinutes();
		
		return {
			date,
			dateString: `${date} ${startHour}-${endHour}`,
			duration,
			endHour,
			startHour
		};
	}

	const getMeeting = async (eventId: string | undefined) => {
		const response: HttpResponse<Meeting> = await get(`/calendar/events/${eventId}`);
		if (response.parsedBody) setMeetingDetails(response.parsedBody);
	}

	const getMeetings = async () => {
		setTabStatus(TabStatus.Loading);
		const queryFilters = filters && Object.keys(filters).map(key => `${key}=${filters[key]?.toISOString()}`).join('&');
		const response: HttpResponse<CalendarItem[]> = await get(`/calendar/events?${queryFilters}`);
		if (response.parsedBody) {
			setMeetings(response.parsedBody);
			setTabStatus(TabStatus.Loaded);
		}
		else setTabStatus(TabStatus.Error);
	}

	const isAllowedToEdit = (meeting: CalendarItem) => {
		return meeting.organizer === userId;
	}

	const navigateTo = (path: string, state?: any, search?: string) => {
		history.push({ pathname: path, search, state });
	}

	const onClickParticipant = (id: string) => {
		if(role !== "ApplicantMentee") {
			const path = userId !== id ? `/members-list/${id}` : '/my-profile';
			navigateTo(path);
		}
	}

	useEffect(() => {
		getMeetings();
	}, [filters]);

	const onUpdateEvent = () => {
		getMeetings();
	}

	const togglePopup = (setStateFunction: React.Dispatch<React.SetStateAction<boolean>>) => {
		setStateFunction((currentValue: boolean) => !currentValue);
	}

	return {
		deleteMeeting,
		formatDate,
		getMeeting,
		getMeetings,
		isAllowedToEdit,
		isAuthorized,
		onClickParticipant,
		onUpdateEvent,
		state: {
			meetingDetails,
			meetings,
			showDeletePopup,
			showDetailsPopup,
			tabStatus
		},
		toggleDeletePopup: () => {
			togglePopup(setShowDeletePopup);
		},
		toggleDetailsPopup: () => {
			togglePopup(setShowDetailsPopup);
		},
		userId
	}
}